import React from 'react';

import { HomeNavigationBar, type TabProp } from '@pkg/components';
import YatDashboardTopBarUserNavigation from '@pkg/components/Dashboard/TopBar/UserNavigation/YatDashboardTopBarUserNavigation';
import { LinkWrapper, StyledNav } from '@pkg/components/Sections/Admin/components/Navigation/AdminNav/styles';
import { useGameSlug } from '@pkg/hooks';

const ADMIN_BASE = '/admin';
const FANTASY_ADMIN_BASE = `${ADMIN_BASE}/fantasy`;

const ADMIN_BASE_LINKS: TabProp[] = [
    { value: `${ADMIN_BASE}/fantasy`, label: 'Fantasy' },
    { value: `${ADMIN_BASE}/fantasy/collections`, label: 'Collections' },
    { value: `${ADMIN_BASE}/groups`, label: 'Emoji Groups' },
    { value: `${ADMIN_BASE}/lootboxes`, label: 'Lootboxes' },
    { value: `${ADMIN_BASE}/organizations`, label: 'Partners' },
    { value: `${ADMIN_BASE}/pods`, label: 'Pods' },
    { value: `${ADMIN_BASE}/promo-codes`, label: 'Promos' },
    { value: `${ADMIN_BASE}/users`, label: 'Users' },
];

const FANTASY_BASE_LINKS: TabProp[] = [
    { value: FANTASY_ADMIN_BASE, label: 'Games' },
    { value: `${FANTASY_ADMIN_BASE}/create`, label: 'Add Game' },
    { value: `${FANTASY_ADMIN_BASE}/collections`, label: 'Collection MGMT' },
];
export const AdminNav = ({ isFantasy = false }: { isFantasy?: boolean }) => {
    const gameSlug = useGameSlug();

    const gameNavLinks: TabProp[] = [
        { value: `${FANTASY_ADMIN_BASE}/${gameSlug}`, label: 'Game' },
        { value: `${FANTASY_ADMIN_BASE}/${gameSlug}/leaderboard`, label: 'Players' },
        { value: `${FANTASY_ADMIN_BASE}/${gameSlug}/rules`, label: 'Rules' },
        { value: `${FANTASY_ADMIN_BASE}/${gameSlug}/faq`, label: 'FAQ' },
        { value: `${FANTASY_ADMIN_BASE}/${gameSlug}/teams`, label: 'Teams' },
    ];

    const fantasyTabs: TabProp[] = [
        { label: 'Admin 🏡', value: '/admin' },
        ...FANTASY_BASE_LINKS,
        ...(gameSlug ? gameNavLinks : []),
    ];

    const tabs: TabProp[] = isFantasy ? fantasyTabs : ADMIN_BASE_LINKS;
    return (
        <StyledNav>
            <HomeNavigationBar tabs={tabs} basePath={ADMIN_BASE} small />
            <LinkWrapper>
                <YatDashboardTopBarUserNavigation variant="v2" />
            </LinkWrapper>
        </StyledNav>
    );
};
